import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PhrutillsService } from '../../generic/phrutills.service';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.css']
})
export class PaymentFailedComponent implements OnInit {

  constructor(private location: Location, private phrUtils: PhrutillsService,) { }

  ngOnInit(): void {
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.phrUtils.setTitle('Pagar el saldo adeudado');
      } else if (language === 'hi') {
        this.phrUtils.setTitle('बकाया राशि का भुगतान करें');
      } else if (language === 'ur') {
        this.phrUtils.setTitle('واجب الادا رقم ادا کریں۔');
      }
      else {
        this.phrUtils.setTitle('Pay Due Balance');
      }
    });
  }

  onClickBack(){
    this.location.back();
  }
}

